module.exports = __webpack_public_path__ + "img/large-cars.85805521.jpeg";